import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class KaraokeManagerPage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="content">
                <div className="container-fluid">
                    <h1 className="text-center">Quản lý karaoke</h1>
                    <hr />
                    
                    <div className="row mt-4">
                        <div className="col-md-6 mb-3">
                            <Link 
                                to="/admin/karaoke-manager/singer" 
                                className="btn btn-primary btn-lg w-100 p-4"
                                style={{ fontSize: "18px" }}
                            >
                                <i className="fa-solid fa-user-tie mr-2"></i>
                                Quản lý ca sĩ
                            </Link>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Link 
                                to="/admin/karaoke-manager/beat" 
                                className="btn btn-success btn-lg w-100 p-4"
                                style={{ fontSize: "18px" }}
                            >
                                <i className="fa-solid fa-music mr-2"></i>
                                Quản lý beat
                            </Link>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Link
                                to="/admin/karaoke-manager/base-song"
                                className="btn btn-warning btn-lg w-100 p-4"
                                style={{ fontSize: "18px" }}
                            >
                                <i className="fa-solid fa-layer-group mr-2"></i>
                                Chuẩn hóa BaseSong
                            </Link>
                        </div>  
                        <div className="col-md-6 mb-3">
                            <Link to="/admin/lyric-detect" className="btn btn-info btn-lg w-100 p-4" style={{ fontSize: "18px" }}>
                                <i className="fa-solid fa-closed-captioning mr-2"></i>
                                Detect lyric
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

